/**
 * Created by razial on 02.05.2024.
 */

const WarehouseIcon = function () {
    SideBarIcon.call(this, {
        animation: bundles.sidebar.jsons.storage_icon_json,
        targets: "warehouse",
        control: "WarehouseIcon"
    });
};

WarehouseIcon.prototype = Object.create(SideBarIcon.prototype);
WarehouseIcon.prototype.constructor = WarehouseIcon;

WarehouseIcon.prototype.onPressed = function () {
    cleverapps.focusManager.display({
        stack: Map2dLocation.currentLocation && Map2dLocation.currentLocation.tutorial.isActive()
            || cleverapps.tutorial.isActive() && cleverapps.tutorial.checkConditions({ advice: "openWarehouse" }),
        focus: "WarehouseIconClicked",
        action: function (f) {
            new WarehouseWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

WarehouseIcon.prototype.resetState = function () {
    this.available = Map2dLocation.currentLocation && Map2dLocation.currentLocation.harvested && Map2dLocation.currentLocation.harvested.getCapacity();

    if (this.available) {
        if (Map2dLocation.currentLocation.harvested.isAlmostFull()) {
            const capacity = Map2dLocation.currentLocation.harvested.getCapacity();
            const amount = Map2dLocation.currentLocation.harvested.getItemsAmount();
            this.setTitle(`${amount}/${capacity}`);
        } else {
            this.setTitle(undefined);
        }
    }
};
